import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_CONTRACTOR_BY_ID';

export async function getContractorById(
    userToken: string,
    id: number
) {
    try {
        const response = await axios.get(
            `${URL}/contractors/${id}/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error: any) {
        const errorMessage = () => {
            if (error.response.data.detail) {
                return error.response.data.detail;
            }
            else {
                return 'Une erreur est survenue';
            }
        };
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: errorMessage(),
            error: error
        });
    }
}
